import { Autocomplete, Grid, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import axios from 'axios';
import dayjs from 'dayjs';
import moment from 'moment';
import React, { memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import { useStyle } from '../style';
import _ from 'lodash';

const QrInfo = ({flag, setData}) => {
  const classes = useStyle();
  const dispatch = useDispatch()
  const [billData, setBillData] = useState([])
  const [docNo, setDocNo] = useState('')
  const [billNo, setBillNo] = useState(null)
  const [address , setAddress] = useState("")
  const [gstIn , setGstIn] = useState("")
  const [partyName , setPartyName] = useState("")
  const [date , setDate] = useState(moment().format())
  
  function handleBillChange(e, value) {
    setBillNo(value);
    if (value) {
      const selectedBill = billData.find((bill) => bill.docno === value.docno);
      // Update state based on the selected bill
      console.log(selectedBill)
      setAddress(selectedBill ? (selectedBill.add1 + " " + selectedBill.add2 + "," + selectedBill.city_name + "-" + selectedBill.pincode + "-" + selectedBill.state_name + "-" + selectedBill.country_name) : '');
      setGstIn(selectedBill ? selectedBill.gstin : '');
      setPartyName(selectedBill ? selectedBill.name : '');
      setDate(selectedBill ? selectedBill.docdate : moment().format());
      setDocNo(value.short_name)
    } else {
      // Clear values if no bill is selected
      setAddress('');
      setGstIn('');
      setPartyName('');
      setDate(moment().format());
      setDocNo('')
    }
  }

  useEffect(()=>{
axios.get('/v1/purchasedocno')
.then(res=>{
  setBillData(res.data)
  setData([])
})
.catch(err=>{
    dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
})
  },[])

  useEffect(()=>{
if(billNo!==null){
  axios.get(`/v1/purchase/${billNo.docno}`)
  .then(res=>{
    const value =  res.data
    _.map(value,(val=>{
      if(val.qty==0){
        dispatch(setSnackbar(true, 'error', 'No QR Code available for this bill.'))
        setBillNo(null)
        setAddress('');
        setGstIn('');
        setPartyName('');
        setDate(moment().format());
        setDocNo('')
        // setData([])
       }
       else{
      const arrData = res.data.map(item => ({
      ...item,
      short_name : docNo,
      retQty: 0,
      totalAmt: parseFloat(item.qty * (item.rate - item.rate * item.dis_per / 100)).toFixed(2)
    }))
    setData(arrData)
    console.log(arrData, res.data ,"qrdattaa")
       }
    }))
   

  })
  .catch(err=>{
    dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
  })
}
  },[billNo, flag])  
  
  return (
    <Grid container spacing={2} className="p-2 h-full" >
         <Grid item lg={4} >
         <Autocomplete 
        id="billNo"
        name="billNo"
        size="small"
        options={billData}
        getOptionLabel={option=> option.docno}
        onChange={(e,value)=>handleBillChange(e,value)}
        value={billNo}
        renderInput={(params)=>(
          <TextField {...params}
          label='Bill No'/>
        )}
        />
         <TextField size="small" label='Party Name' fullWidth sx={{marginBlock:1.5}} value={partyName}/>
         <TextField size="small" label='Address' disabled multiline rows={3.3} fullWidth value={address}/>
         </Grid>
        <Grid item lg={4}>
        <TextField size="small" label='Supplier Code' fullWidth 
        value={docNo}
        InputProps={{
          readOnly: true,
        }} />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker value={dayjs(date)} label="Date" size="small"  slotProps={{
                  textField: {
                    size: "small",
                  },
                }}
                
                sx={{width: '100%',marginBlock:1.5}}
                />
        </LocalizationProvider>
        <TextField size="small" label='GSTIN' fullWidth disabled value={gstIn}/>
        </Grid>
    </Grid>
  );
};

export default memo(QrInfo)